import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _withScopeId = n => (_pushScopeId("data-v-f7fcec44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__report-lesson" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_4 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_7 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_8 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_9 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_10 = { class: "bg-neutral-100 h-16" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16"
}, " STT ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}, " ngày học ", -1))
const _hoisted_13 = {
  key: 0,
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}, " Mục tiêu ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}, " Cảm xúc ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}, " Mức độ tham gia ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " PH ĐÃ XEM ", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_20 = { class: "px-3 py-4" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "px-3 py-4"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  class: "px-3 py-4",
  style: {"max-width":"140px","margin-right":"40px"}
}
const _hoisted_27 = {
  class: "px-3 py-4",
  style: {"min-width":"70px","max-width":"140px","margin-right":"40px"}
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "px-3 py-4",
  style: {"max-width":"140px","margin-right":"40px"}
}
const _hoisted_30 = {
  style: {"width":"100px"},
  class: "px-3 py-4 capitalize whitespace-nowrap"
}
const _hoisted_31 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col mt-20"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-lg max-w-lg text-center" }, " Học sinh chưa có báo cáo nhóm nào. ", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rating = _resolveComponent("Rating")!
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.LessonReportsList && _ctx.LessonReportsList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LessonReportsList, (list, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(list.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                              _createElementVNode("thead", _hoisted_10, [
                                _createElementVNode("tr", null, [
                                  _hoisted_11,
                                  _hoisted_12,
                                  (
														_ctx.org.enable_report_by_session
													)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_13, " Giờ học "))
                                    : _createCommentVNode("", true),
                                  _hoisted_14,
                                  _hoisted_15,
                                  _hoisted_16,
                                  _hoisted_17
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.data, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.id,
                                    onClick: ($event: any) => (
													item.state !== 'created' &&
														_ctx.$router.push({
															path: `/report/lesson/${item.date}`,
															query: {
																..._ctx.$route.query,
																student_id:
																	item
																		?.student
																		?.id,
															},
														})
												),
                                    class: _normalizeClass([[
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50',
													item.state !== 'created'
														? 'cursor-pointer'
														: '',
												], "text-neutral-700 hover:bg-orange-50"])
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_19, _toDisplayString(index + 1), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_20, [
                                        (item.date)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$filters.formatDate2(
																	item.date
																)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (
														_ctx.org.enable_report_by_session
													)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                          (item?.session)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                (
																item?.session
																	?.display_start_slot
															)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item?.session
																	?.display_start_slot), 1))
                                                  : _createCommentVNode("", true),
                                                (
																item?.session
																	?.display_end_slot
															)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "- " + _toDisplayString(item?.session
																	?.display_end_slot), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_26, _toDisplayString(item?.assessment_count), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_27, [
                                        (
																item?.emotion_scale
															)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: 
																require(`@/assets/images/emoji/${
																	_ctx.$filters.emoji(
																		item?.emotion_scale +
																			''
																	).emoji
																}`)
															,
                                              alt: "",
                                              height: "24",
                                              width: "24"
                                            }, null, 8, _hoisted_28))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_Rating, {
                                          rating: 
																item?.cooperation_scale
															
                                        }, null, 8, ["rating"])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_30, _toDisplayString(item.numbers_of_parent_read) + "/ " + _toDisplayString(item.total_parent_count), 1)
                                    ])
                                  ], 10, _hoisted_18))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.isInfinityLoading)
                  ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                      key: 0,
                      onInfiniteLoad: _ctx.getLessonList,
                      loaded: _ctx.stopLoad,
                      "is-loading": _ctx.isLoading
                    }, null, 8, ["onInfiniteLoad", "loaded", "is-loading"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode(_component_Loading)
        ]))
  ]))
}